angular.module('app.controllers', [])
  .controller 'EmptyCtrl', ['$scope', '$location'].append (self, $location) -> 
    
    self.tab = 1
    self.tab_pre = false
    
    params = $location.search()

    if params && angular.isDefined(params.tab)
      self.tab_pre = true
      self.tab = parseInt(params.tab)
